import { helper } from '@ember/component/helper';

export default helper(function progressToBg([progress]) {
  if (progress === 'ON_TRACK') {
    return 'bg-green-300 text-green-600';
  } else if (progress === 'NEEDS_REVIEW') {
    return 'bg-blue-300 text-blue-600';
  } else if (progress === 'AT_RISK') {
    return 'bg-amber-300 text-amber-600';
  } else if (progress === 'DELAYED') {
    return 'bg-red-300 text-red-600';
  } else {
    return 'bg-gray-300 text-gray-900';
  }
});
